import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])
export const pageSearch = {
  'billStatus': {
    title: '要货状态',
    type: 'select',
    equation: all,
    dictionary: 'wantgoodStatus',
    defaultVal: 'E002'
  },
}
export default {
  'wantCode': {
    title: '要货单号',
    type: 'input',
    slot: true,
    width: 100
  },
  /*'billCode': {
    title: '编号',
    type: 'input',
    equation: cusname,
    width: 160
  },*/
  'customerCode': {
    title: '订单客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '订单客户'
    },
    width: 120
  },
  'customerName': {
    title: '订单客户名称',
    width: 200
  },
  'saleCenter': {
    suffix: 'TextView',
    describe: true, // 描述 _text 添加属性
    title: '营销战区', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'sale' // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
    ,width: 120
  },
  'brandBq': {
    describe: true,
    suffix: 'TextView',
    title: '存货分类',
    type: 'select',
    dictionary: 'A0019',
    width: 140
  },
  'archiveDate': {
    title: '归档日期',
    width: 110
  },
  'archiveTime': {
    title: '归档时间',
    type: 'date',
    equation: cusname,
    valueFormat: 'yyyy-MM-dd',
    width: 140
  },
  'createdTime': {
    title: '申请日期',
    width: 110
  },
  'createdDated': {
    title: '申请时间',
    type: 'date',
    equation: cusname,
    valueFormat: 'yyyy-MM-dd',
    width: 140
  },
  'isShunt': {
    title: '是否分流',
    formatter: ({ cellValue }) => cellValue === '1' ? '是' : '否',
    width: 90
  },
  /*('shuntDealer': {
    title: '分流经销商',
    width: 200
  },
  'kaStoreFullname': {
    title: '卖场全称'
  },*/
  'planType': {
    suffix: 'TextView',
    describe: true,
    title: '要货类型',
    type: 'select',
    dictionary: 'A0002',
    width: 180
  },
  'productCode':{
    title: '产品编码',
    width: 150
  },
  'productDesc': {
    title: '产品名称',
    width: 200
  },
  'quotasYear': {
    title: '配额年度',
    width: 90
  },
  'receiveAddress': {
    title: '收货地址',
    width: 200
  },
  'wantQuantity': {
    title: '申请量',
    width: 80
  },
  'handleNode': {
    title: '节点',
    type: 'select',
    equation: cusname,
    dictionary: 'handleNode',
    defaultVal: ['销售内勤', '电商渠道'],
    dictionaryVal: [
      { name: '销售内勤', value: '销售内勤' },
      { name: '渠道经理', value: '渠道经理' },
      { name: '基地经理', value: '基地经理' },
      { name: '战区经理', value: '战区经理' },
      { name: '电商渠道', value: '电商渠道' },
      { name: '销售计划部', value: '销售计划部' },
    ]
  },
  'billStatusTextView': {
    title: '要货状态',
    width: 90
  },
   'invoId': {
    title: '发票号',
    width: 100,
    type: 'input',
  },
  'makDate': {
    title: '开票日期',
    type: 'date',
    equation: cusname,
    valueFormat: 'yyyy-MM-dd',
    width: 110
  },
  'useZzfld9': {
    title: '开票量',
    xlsxFmt: {
      t: 'n'
    }, width: 80
  },
  'deliverQty': {
    title: '占用量',
    type: 'input',
    equation: cusname,
    xlsxFmt: {
      t: 'n'
    }, width: 80
  },
  'shipStatus': {
    describe: true,
    suffix: 'TextView',
    title: '安吉状态',
    type: 'select',
    equation: city,
    dictionary: 'B0101',
    width: 100
  },
   'remark': {
    title: '备注',
    width: 200,
    type: 'input',
  },
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/shipmentDtlInfoForms.js